<script setup lang="ts">
import UnifiedBackBarIA from '~/components/Unified/IA/UnifiedBackBarIA.vue';
import { useBackButtonPlace, useOneLeaving } from '~/composables/unified/useBackButtonPlace';
import { PUBLIC_BACK_PLACE_ROUTES, publicBackPlace, publicHomePlace } from '~/utils/unified/publicBackPlace';

/**
 * The guest's way back from a detail page under the new information architecture, the same button
 * the coach shell draws above it for a signed-in student: back to the page it was opened from,
 * naming that place, or, with nothing of ours behind it (a link or a reload landed on it), to the
 * place the page belongs to.
 */
const router = useRouter();
const { fallback, label } = useBackButtonPlace({
  backPlace: publicBackPlace,
  homePlace: publicHomePlace,
  routes: PUBLIC_BACK_PLACE_ROUTES,
});

const leaveOnce = useOneLeaving();

const goBack = () => leaveOnce(() => {
  if (fallback.value) {
    void navigateTo(fallback.value);
    return;
  }
  router.back();
});
</script>

<template>
  <UnifiedBackBarIA
    :label="label"
    test-id="public-back-button"
    @back="goBack"
  />
</template>
